<template>
    <div>
        <modal v-model="choosingChildOrClass" size="xl" title="" class="observeChildrenSelect">
            <select-class
                v-if="!selectedChild && (!selectedClass || selectedClass?.id === 0)"
                v-on:selected-class="setClass"/>

            <div v-else>
                <h6 class="text-center">{{ trans('general.quick_call.select_child') }}</h6>
                <custom-radio
                    v-if="children && selectedClass"
                    v-model="selectedChild"
                    ref="selectChild"
                    :items="children"
                    type="grid"/>
            </div>
        </modal>

        <modal v-model="observationModal" :title="trans('general.observations.observe_child_dev')">
            <observation-form
                v-if="loaded && child.group_id"
                ref="developmentForm"
                :child-id="child.id"
                :class-id="child.group_id"
                :status-data="statusData"
                :roles="roles"
                @observationAdded="observationAdded"
                @addNote="addNote" />
        </modal>

        <development-topic-note-modal
            ref="developmentTopicNoteModal"
            @success="reload"
            @close="noteClosed"/>
    </div>
</template>

<script>

import Modal from "../Modal.vue";
import CustomRadio from "../../molecules/CustomRadio.vue";
import axios from "axios";
import ChildObservations from "../../../modules/Children/organisms/tabs/ChildObservations.vue";
import DevelopmentTopicNoteModal from "../../../modules/Children/organisms/ObservationTopicNoteModal.vue";
import ObservationForm from "../../../modules/Children/molecules/ObservationForm.vue";
import SelectClass from "../../../widgets/DailyReportWidget/molecules/SelectClass.vue";

export default {
    name: "ObserveChildren",
    components: {SelectClass, ObservationForm, DevelopmentTopicNoteModal, ChildObservations, CustomRadio, Modal},
    props: {
        roles: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            choosingChildOrClass: false,
            selectedChild: null,
            children: null,
            child: null,
            observationModal: false,
            loaded: false,
            statusData: null,
            selectedClass: null,
        };
    },
    watch: {
        selectedChild: function (child) {
            if (child) {
                this.openObservationModal(child.data);
            } else {
                this.observationModal = false;
            }
        },
    },
    methods: {
        openObservationModal(child) {
            this.child = child;
            this.choosingChildOrClass = false;
            this.observationModal = true;
            this.getSelectedClass();
            this.loadStatusDevelopmentReportData();
        },
        getSelectedClass() {
            this.selectedClass = null;
            const selectedGroup = localStorage.getItem('selectedClass');
            if (selectedGroup && selectedGroup !== 'null') {
                const group = JSON.parse(selectedGroup);
                if (group && group.id) {
                    this.selectedClass = group;
                }
            }
        },
        init(child = null) {
            this.getSelectedClass();
            this.selectedChild = null;

            if (child) {
                this.openObservationModal(child);
            } else {
                if (this.selectedClass) {
                    this.children = null;
                    this.getChildren();
                }
                this.choosingChildOrClass = true;
            }
        },
        getChildren() {
            const params = {
                include: 'image',
                order_by: 'name',
                search: 'group_id:' + this.selectedClass.id,
            };

            axios.get('/children', {params})
                .then(response => {
                    this.choosingChildOrClass = true;

                    let items = [];
                    response.data.data.data.forEach((item) => {

                        if (item.image) {
                            item.image = item.image.absolute_path;
                        } else {
                            item.image = '/img/avatar.png';
                        }

                        items.push({
                            value: item.id,
                            cls: 'user',
                            text: `<img src="${item.image}" class="avatar"/> <span>${item.name} ${item.surname}</span>`,
                            color: 'text',
                            data: item,
                        });
                    });

                    this.children = items;
                });
        },
        async loadStatusDevelopmentReportData() {
            this.loaded = false;
            const {data} = await axios.get(`/development-reports/${this.child.id}/data-status`)
            this.statusData = data.data;

            this.loaded = true;
        },
        addNote(data) {
            this.observationModal = false;
            this.$refs.developmentTopicNoteModal.open(data);
        },
        reload() {
            this.noteClosed();
            this.$refs.developmentForm.reload();
        },
        noteClosed() {
            this.observationModal = true;
        },
        observationAdded() {
            this.$emit('reload-today-reports', this.child);
        },
        setClass(classData) {
            this.selectedClass = classData;
            this.selectedChild = null;
            this.getChildren();
        },
    },
};
</script>
